<content-panel
  #panel
  [itemsCount]="totalCount"
  [hidden]="docId && docId != impacterId"
  [loading]="currentRequest && !currentRequest.closed"
>
  <ng-template contentPlaceholder>
    <div class="content-state">
      <div class="state-title">{{ 'search-placeholder.smart-search-feature.title' | translate }}</div>
      <div class="state-subtitle">{{ 'search-placeholder.smart-search-feature.subtitle' | translate }}</div>
      <img
        class="state-media cursor-pointer"
        src="assets/images/feature-thumbnail-smart-search.svg"
        alt="smart-search-video"
        (click)="openSmartSearchIntro()"
      />
    </div>
  </ng-template>
  <ng-template contentList [items]="articles" [headerTemplate]="headerTemplate" [itemTemplate]="itemTemplate"> </ng-template>
  <ng-template contentFooter>
    @if (nbPages > 1) {
      <app-pagination [nbPages]="nbPages" [stats]="dataUpdated" [inImpacterView]="!!impacterId"></app-pagination>
    }
  </ng-template>
  <ng-template contentLoading>
    <div class="content-loading">
      <ex-overlay-loader direction="column" color="secondary" [text]="'search.loading' | translate"></ex-overlay-loader>
    </div>
  </ng-template>
  <ng-template contentEmpty>
    <div class="content-state">
      <mat-icon svgIcon="close-circle-fill"></mat-icon>
      <div class="state-title">{{ 'content.no-result-message' | translate }}</div>
      <div class="state-subtitle">
        {{ 'content.indicative-no-result-message' | translate }}
      </div>
    </div>
  </ng-template>
</content-panel>
<section [hidden]="!docId || impacterId === docId">
  <router-outlet></router-outlet>
</section>

<ng-template #headerTemplate>
  <div class="results-header results-header-item">
    <div class="flex-1">
      <div class="results-title">
        {{ (totalCount == 10000 ? 'search.more-than' : '') | translate }}
        {{ totalCount?.toLocaleString() }}
        {{ (totalCount && totalCount > 1 ? 'search.results' : 'search.result') | translate }}
        @if (currentRequest && !currentRequest.closed) {
          <i class="ph-bold ph-circle-notch header-loader"></i>
        }
      </div>
      <div class="results-subtitle">
        @if (impacterId) {
          <span>
            {{
              (impacterArticlesCount > 1 ? 'search.article-results' : 'search.article-result')
                | translate: { totalCount: impacterArticlesCount.toLocaleString() }
            }}
          </span>
        } @else {
          <span>
            {{
              (articlesCount > 1 ? 'search.article-results' : 'search.article-result')
                | translate: { totalCount: articlesCount.toLocaleString() }
            }}
            {{
              (sourcesCount > 1 ? 'search.article-sub-results' : 'search.article-sub-result')
                | translate: { nbWebsite: sourcesCount.toLocaleString() }
            }}
          </span>
          <i class="ph ph-info" [ngbTooltip]="sources" tooltipClass="custom-tooltip-sources" placement="bottom auto"></i>
        }
      </div>
    </div>
    <ex-button
      data-cy="smart-search-toggle"
      type="ai"
      variant="tonal"
      size="medium"
      class="align-items-center"
      (click)="!smartSearchService.panelOpen() && panel.scrollToTop(); smartSearchService.toggleSmartSearchTrigger()"
      [icon]="smartSearchService.panelOpen() ? 'caret-double-up-bold' : 'caret-double-down-bold'"
      iconPosition="right"
    >
      @if (smartSearchService.panelOpen()) {
        {{ 'search.smart-search-button-close' | translate }}
      } @else {
        {{ 'search.smart-search-button' | translate }}
      }
    </ex-button>
  </div>
  <app-smart-search-panel
    class="results-header-item"
    [searchConfig]="smartSearchService.context()"
    [hidden]="!smartSearchService.panelOpen()"
    [count]="entities.length"
  />
</ng-template>
<ng-template #itemTemplate let-item>
  <app-article-card
    data-cy="article-card"
    [bookmarkPaths]="item.bookmarkPaths"
    [docId]="item.id"
    [title]="item.title"
    [publicationDate]="item.publicationDate"
    [source]="item.source"
    [nbOccurrences]="item.occurrenceCount"
    [text]="$safeNavigationMigration(item.excerpts?.[0])"
    [territories]="item.territories"
    [photoCount]="$safeNavigationMigration(item.html?.nbImages)"
    [impacterId]="impacterId"
  />
</ng-template>
<ng-template #sources>
  <ul class="sources-list">
    @for (source of sourcesList; track source) {
      <li class="source">{{ source }}</li>
    }
  </ul>
</ng-template>
